import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';

import * as associationsStyles from './associations.module.css';

export const Associations = () => {
  return (
    <section className={associationsStyles.associations}>
      <a href="https://cnarea.ca/">
        <StaticImage
          width={150}
          src="../images/cnarea_logo.png"
          alt="Canadian National Association of Real Estate Appraisers logo"
        />
      </a>
    </section>
  );
};
